import { render, staticRenderFns } from "./SpecialPage.vue?vue&type=template&id=cc4eece2&scoped=true"
import script from "./SpecialPage.vue?vue&type=script&lang=js"
export * from "./SpecialPage.vue?vue&type=script&lang=js"
import style0 from "./SpecialPage.vue?vue&type=style&index=0&id=cc4eece2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4eece2",
  null
  
)

export default component.exports